export default {
  HOME: 'Home',
  ACTIVITY: 'Activity',
  PLANS: 'Plans',
  FUNDS: 'Plans',
  HELP: 'Help',
  GET_CARE: 'Get Care',
};
